import axios from "axios";

export const organizationFactory = prefix => ({
  async create(data) {
    const response = await axios({
      method: "post",
      url: `${prefix}/organization`,
      data,
    });

    return response.data.result;
  },
  async getByGuid(organizationGuid) {
    const response = await axios({
      method: "get",
      url: `${prefix}/organization/guid?organizationGuid=${organizationGuid}`,
    });

    return response.data.result;
  },

  async getByOrganizationId(organizationId) {
    const response = await axios({
      method: "get",
      url: `${prefix}/organization/${organizationId}`,
    });

    return response.data.result;
  },

  async list() {
    const response = await axios({
      method: "get",
      url: `${prefix}/organization`,
    });

    return response.data.result;
  },

  async listAdmin() {
    const response = await axios({
      method: "get",
      url: `${prefix}/admin/organization`,
    });

    return response.data.result;
  },

  async snapshot() {
    const response = await axios({
      method: "post",
      url: `${prefix}/snapshot`,
    });

    return response.data.result;
  },

  async syncUsers(organizationId) {
    const response = await axios({
      method: "get",
      url: `${prefix}/organization/${organizationId}/syncUsers`,
    });
    return response.data.result;
  },

  async update(organizationId, attributeValueHash) {
    const attributeList = Object.keys(attributeValueHash);

    attributeList.forEach(attribute => {
      if (attributeValueHash[attribute] === "null")
        attributeValueHash[attribute] = null;
    });

    const response = await axios({
      data: attributeValueHash,
      method: "put",
      url: `${prefix}/organization/${organizationId}`,
    });

    return response.data.result;
  },
});

export const organizationAdminApi = organizationFactory("/api/admin");

export const organizationApi = organizationFactory("/api");
export default organizationApi;
